/* eslint-disable */
import React, {
  ChangeEvent,
  ChangeEventHandler,
  FC,
  FocusEventHandler,
} from 'react';
import useToggle from '../useToggle';
import SwitchStyle from './switch.style';

type Props = {
  className: string;
  isMaterial: boolean;
  labelText: string;
  switchSize: string;
  switchColor?: string;
  labelPosition?: 'top' | 'bottom' | 'left' | 'right';
  isChecked?: boolean;
  barColor?: string;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  onChange?: (checked: boolean) => void;
  handleOnChange?: ChangeEventHandler<HTMLInputElement>;
  isDisabled?: boolean;
};

const Switch: FC<Props> = ({
  className,
  switchColor,
  isChecked = false,
  labelText,
  labelPosition = 'top',
  switchSize,
  isMaterial,
  barColor,
  onChange = () => {},
  onFocus = () => {},
  onBlur = () => {},
  handleOnChange = () => {},
  isDisabled,
  ...props
}) => {
  // use toggle hooks
  const [toggleValue, toggleHandler] = useToggle(isChecked);

  // Add all classs to an array
  const addAllClasses = ['reusecore__switch'];

  // Add label position class
  if (labelPosition) {
    addAllClasses.push(`label_${labelPosition}`);
  }

  // isMaterial prop checking
  if (isMaterial) {
    addAllClasses.push('is-material');
  }

  // className prop checking
  if (className) {
    addAllClasses.push(className);
  }

  handleOnChange = (event) => {
    toggleHandler();
    onChange(!toggleValue);
  };

  const LabelField = labelText && (
    <span className="reusecore__field-label">{labelText}</span>
  );

  const position = labelPosition || 'top';

  return (
    <SwitchStyle
      className={addAllClasses.join(' ')}
      switchColor={switchColor}
      switchSize={switchSize}
      barColor={barColor}
      {...props}
    >
      <label>
        {position === 'left' || position === 'right' || position === 'top'
          ? LabelField
          : ''}

        <input
          checked={toggleValue}
          onChange={handleOnChange}
          onBlur={onBlur}
          onFocus={onFocus}
          className="switch"
          type="checkbox"
          value={toggleValue}
          disabled={isDisabled}
        />
        <div>
          <div />
        </div>
        {position === 'bottom' && LabelField}
      </label>
    </SwitchStyle>
  );
};

export default Switch;
